import { FelaCSS } from '@bridebook/ui';

interface IStyles {
  wrapper: FelaCSS;
  image: FelaCSS;
  content: FelaCSS;
  title: FelaCSS;
  tag: FelaCSS;
}

const styles = (): IStyles => ({
  wrapper: {
    minWidth: '250px',
    flexGrow: 1,
    borderRadius: '8px',
    overflow: 'hidden',
  },

  image: {
    minHeight: 500,
    paddingTop: '75%',
    shimmer: true,
    borderRadius: 16,
  },

  content: {
    gap: 10,
    height: '123.2px',
    borderEndEndRadius: '8px',
    borderEndStartRadius: '8px',
    padding: 4,
    borderTop: 'none',
  },

  title: {
    width: '80%',
    height: '20px',
    borderRadius: '2px',
    shimmer: true,
  },

  tag: {
    width: '40%',
    height: '12px',
    borderRadius: '2px',
    shimmer: true,
  },
});

export default styles;
